import { render, staticRenderFns } from "./aiTe.vue?vue&type=template&id=1b0a2944&scoped=true"
import script from "./aiTe.vue?vue&type=script&lang=js"
export * from "./aiTe.vue?vue&type=script&lang=js"
import style0 from "./aiTe.vue?vue&type=style&index=0&id=1b0a2944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a2944",
  null
  
)

export default component.exports